export default __webpack_public_path__ + "static/media/Slw-Series-Double-Suction-Horizontal-End-Suction-Centrifugal-Pump.4abdbe92.jpg";